import { api } from "~/api";
import { defineComponent, reactive, ref } from "vue";
import { MsgBox } from "~/components/MsgBox";
import { Log } from "~/extensions/utils";
import { myPageStore } from "~/store/MyPageStore";
import { RoomSb, userType, PageID } from "~/extensions/utils/DefineTypes";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
import { commonStore } from "~/store/CommonStore";
import { store } from "~/pages/taikyo/store/TaikyoStore";
const log = Log.create("TaikyoEntryComplete");
const isNotification = ref(false);
export default defineComponent({
    components: {
        BreadcrumbList
    },
    name: "TaikyoEntryCompletePage",
    beforeRouteEnter(to, from, next) {
        const fromScreen = from.name;
        const relatedScreens = ["taikyo-entry-check"];
        isNotification.value = false;
        if (relatedScreens.includes(fromScreen)) {
            next();
            return;
        }
        const relatedNotificationScreens = ["taikyo-notification-entry-check"];
        if (relatedNotificationScreens.includes(fromScreen)) {
            isNotification.value = true;
            next();
            return;
        }
        next({ name: "taikyo" });
    },
    async setup() {
        const isMultipleKeiyaku = myPageStore.isMultipleKeiyaku;
        const isKojin = myPageStore.personal.userKb === userType.Kojin;
        const roomSb = myPageStore.selectedNyukyokeiyaku.roomSb;
        const isSave = history.state.isSave;
        let html = reactive({
            value: ""
        });
        // 画面名取得
        const pageName = commonStore.pageName(PageID.taikyoEntryComplete);
        try {
            let result = await api.taikyo.loadEntryCompleteText();
            html.value = result;
        }
        catch (ex) {
            log.error("setup", ex);
            MsgBox.error(ex.message);
        }
        return {
            isMultipleKeiyaku,
            isKojin,
            roomSb,
            RoomSb,
            html,
            isNotification,
            userType,
            isSave,
            pageName,
            PageID,
            store
        };
    }
});
